import axios from 'axios'
import util from '@/libs/util.js'
import qs from 'qs'
import storejs from "store";

let baseURL = `${window.location.protocol}//${window.location.host}/`;

const logout = function() {
  util.cookies.remove('token');
  util.cookies.remove('uuid');
  window.location.href = "/";
}

axios.interceptors.request.use((request) => {
  const token = util.cookies.get('token')
  const pubToken = storejs.get("publicData") && storejs.get("publicData").token ? storejs.get("publicData").token : '';
  // 给所有请求添加自定义header
  request.headers['open-token'] = token ? token : pubToken 
  request.baseURL = baseURL
  console.log(request)
  if ( request.method  === 'post' ) {
    if(typeof request.data === "object"){
      request.data.ts = (new Date()).getTime()
      request.data = qs.stringify(request.data)
    }
    
    // request.body = util.objToParameter(request.body)
  }
  return request
})

//拦截请求
axios.interceptors.response.use(
  (response) => {
      //只将请求结果的data字段返回
      console.log('response',response)
      // retre
      if ( response.data.code === 403 || response.data.code === 401 ) {
        logout();
      }
      if ( response.data.t && response.data.code === 0 && typeof response.data.t.totalElements === "number" ) {
        return {
          list: response.data.t.content,
          pagination: {
            firstPage: response.data.t.firstPage,
            lastPage: response.data.t.lastPage,
            pageNumber: response.data.t.pageNumber,
            pageSize: response.data.t.pageSize,
            totalElements: response.data.t.totalElements,
            totalPages: response.data.t.totalPages
          }
        }
      } else {
        return response.data
      }
  },
  (err) => {
    if ( err.status === 401 ) {
      logout();
    };
    //发生网络错误后会走到这里
    //return Promise.resolve("ssss")
  }
)
